import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=22d5dafa&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d5dafa')) {
      api.createRecord('22d5dafa', component.options)
    } else {
      api.reload('22d5dafa', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=22d5dafa&", function () {
      api.rerender('22d5dafa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TN2Ec1A9uoO2/JS/comp/CurrentYear.vue"
export default component.exports